module.exports = __webpack_public_path__ + "img/icon88.7c935690.png";